import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Styles from "./index.module.scss";
import Service from "../service";
import { hideLoading, showLoading } from "@/components/loading";
import { Toast } from "antd-mobile";
import ListView from "@/components/AntListView";
import qs from "query-string";

const formatTime = (value) => {
  if (!value) return "-";
  return String(value).replace(/-/g, ".");
};

const RecycleRecord = () => {
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [totalInvest, setTotalInvest] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const currentPage = useRef(1);
  const pageSize = useRef(10);
  const recIdRef = useRef(qs.parse(window.location.search)?.recId);
  const loadingRef = useRef(false);

  const getData = async (loading = false, isRefresh = true) => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    try {
      if (loading) showLoading();
      if (isRefresh) currentPage.current = 1;
      else currentPage.current = currentPage.current + 1;

      if (!recIdRef.current) {
        const initRes = await Service.gemsInit();
        recIdRef.current = initRes?.data?.recId;
      }
      if (!recIdRef.current) throw "活动信息异常";

      const res = await Service.gemsRecLogs(
        recIdRef.current,
        currentPage.current,
        pageSize.current
      );
      if (loading) hideLoading();
      if (res.code && res.code !== "000000") throw res.msg || "获取回收记录失败";

      const list = res?.data?.records || [];
      const totalCount = Number(res?.data?.total || 0);
      const invest = Number(list[0]?.investTotal ?? res?.data?.investTotal ?? 0);
      if (isRefresh) setTotalInvest(invest);

      setIsLoad(true);
      setRecords((prev) => {
        const next = currentPage.current === 1 ? list : [...prev, ...list];
        const nextHasMore =
          (list?.length || 0) >= pageSize.current &&
          (totalCount ? next.length < totalCount : true);
        setHasMore(nextHasMore);
        return next;
      });
    } catch (error) {
      hideLoading();
      setIsLoad(true);
      setHasMore(false);
      Toast.show(error?.message || error || "获取回收记录失败");
    } finally {
      loadingRef.current = false;
    }
  };

  const loadMore = async () => {
    await getData(false, false);
  };

  const onRefresh = async () => {
    await getData(false, true);
  };

  useEffect(() => {
    getData(true, true);
  }, []);

  const handleBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  };

  const RecordItem = (item, index) => {
    const time = formatTime(item.changeTime);
    const count = item.changeCount ?? 0;
    return (
      <div className={Styles.recordCard} key={item.id || `${time}-${index}`}>
        <div className={Styles.timeRow}>
          <span className={Styles.label}>回收时间</span>
          <span className={Styles.time}>{time}</span>
        </div>
        <div className={Styles.countRow}>宝石个数: {count}</div>
      </div>
    );
  };

  return (
    <div className={Styles.recycleRecordPage}>
      <div className={Styles.statusBar}></div>
      <div className={Styles.navBar}>
        <div className={Styles.backButton} onClick={handleBack}></div>
        <div className={Styles.title}>回收记录</div>
        <div className={Styles.placeholder}></div>
      </div>
      <div className={Styles.summary}>当前活动总投入：{totalInvest}</div>
      <div className={Styles.content}>
        <ListView
          dataSource={records}
          hasMore={hasMore}
          renderItem={RecordItem}
          onRefresh={onRefresh}
          onEndReached={loadMore}
          isLoad={isLoad}
          emtyDesc="暂无回收记录"
        />
      </div>
    </div>
  );
};

export default RecycleRecord;
